import { render, staticRenderFns } from "./MAppAccount.vue?vue&type=template&id=6a981b58"
import script from "./MAppAccount.vue?vue&type=script&lang=ts"
export * from "./MAppAccount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AIcon: require('/codebuild/output/src3569707009/src/app/components/atoms/Media/AIcon.vue').default,AGapText: require('/codebuild/output/src3569707009/src/app/components/atoms/AGapText.vue').default,AMenu: require('/codebuild/output/src3569707009/src/app/components/atoms/Menu/AMenu.vue').default})
